import {getToken} from "./TokenHelper";

export const getHeaderJwtJson = () => ({
  "Authorization": "Bearer " + getToken(),
  "Accept": "application/json",
  "Content-Type": "application/json"
});

export const getHeaderNotJwtJson = () => ({
  "Accept": "application/json",
  "Content-Type": "application/json"
});

export const getOnlyJwt = () => ({
  "Authorization": "Bearer " + getToken()
});


